<template>
  <v-dialog
    v-model="showDialog"
    width="400px"
    @closed="handleClosed"
    @open="handleOpen">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>Edit {{getOptionName('carClassOption.make',form.make_id)}} Grade</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="handleClosed"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div
            v-for="(item,index) in company_list"
            :key="'company_list_'+index"
            class="form-item">
            <span>{{item.company}}</span>
            <el-form-item
              :ref="`class.${index}.grade`"
              :rules="rules.select"
              :prop="`class.${index}.grade`"
            >
              <v-select
                v-model="item.grade"
                :list="carClassCompanyList(item.company_id,item.trm_of_cvr)"></v-select>

            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="handleClosed">Cancel</v-button>
        <v-button
          green
          @click="handlerSave">Save</v-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {updateCarModelClassList} from '@api/privateCarList'
export default {
  name: 'eidt-grade-dialog',
  mixins: [MixinOptions, MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    form:{
      type:Object,
      default:()=>({})
    },
    classId:{
      type:Number,
      default:11
    }
  },
  data(){
    return{
      showDialog:false,
      formData:{
      }
    }
  },
  computed:{
    carClassCompanyList(){
      return (company_id,trm_of_cvr)=>{
        let class_company = this.carClassOption.class||{}
        if(trm_of_cvr){
          return class_company[company_id][trm_of_cvr]||[]
        }
        return class_company[company_id][0]||[]
      }
    },
    company_list(){
      return this.formData.class||[]
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        if(val){
          this.formData=this.form
        }
        this.showDialog = val
      }
    }
  },
  methods:{
    handleOpen(){

    },
    handlerSave(){
      this.$refs['form'].validate((valid,rules) => {
        if (valid) {
          this.network().updateCarModelClassList()
        } else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handleClosed(){
      this.showDialog =false
      this.$emit('input',this.showDialog)
    },
    network(){
      return {

        updateCarModelClassList: async(params) =>{
          let list = [{...this.formData,id:this.form.id}]
          params = {
            list,
            class_id:this.classId
          }
          const {data} = await updateCarModelClassList(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
          this.$emit('refresh')
          this.showDialog = false
          this.$emit('input',this.showDialog)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  color: #616266;

  h1 {
    font-size: 24px;
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -15px;
    padding: 0 15px 15px 15px;
    border-bottom: 1px solid #dddfe7;

    h1 {
      font-size: 24px;
    }
  }
  .dialog-body{
    margin-top: 25px;
    padding-bottom: 10px;
  }
  .dialog-content {
    padding-top: 15px;

    & > div {
      flex: 1;
    }

    .left {
      margin-top: -15px;
      padding-right: 15px;
      padding-top: 15px;
      border-right: 1px solid #dddfe7;
    }

    .right {
      padding-left: 15px;
    }

    .form-box {
      margin-bottom: 10px;

      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }
}
</style>
